<template>
  <div>
    <v-card
      elevation="1"
      class="card card-mobile"
      flat
      style="margin-left: 3rem; margin-right: 1rem; border-radius: 15px"
    >
      <v-system-bar height="60px" class="card-header-systembar">
        <label
          class="ml-5 my-5"
          style="color: #444444; font-size: 20px !important"
          >Company Management</label
        >
      </v-system-bar>

      <!-- ******** header, add new -->
      <v-layout row align-center class="ml-7 mt-10">
        <v-flex xs8 sm6 md6 lg4 xl2>
          <title-block
            :relative="$vuetify.breakpoint.name !== 'xs' ? true : false"
            width="300"
            height="60"
            class="company-title-text-mobile"
            >{{ $t("companymanagement") }}</title-block
          >
        </v-flex>
      </v-layout>

      <!-- ******** switch & search-->
      <v-layout row class="ml-7 mt-5">
        <v-flex xs4 sm3 md3 lg2 xl1>
          <v-btn
            block
            outlined
            class="text"
            @click="onClickRunning"
            :style="{
              'border-radius': '5px 0 0 5px',
              height: '40px',
              'text-transform': 'none',
              'background-color': running.backcolor,
              color: running.color,
              border: running.border
            }"
            >{{ $t("running") }}</v-btn
          >
        </v-flex>
        <v-flex xs4 sm3 md3 lg2 xl1>
          <v-btn
            block
            class="text"
            outlined
            @click="onClickRemoved"
            :style="{
              'border-radius': '0 5px 5px 0',
              height: '40px',
              'text-transform': 'none',
              'background-color': removed.backcolor,
              color: removed.color,
              border: removed.border
            }"
            >{{ $t("removed") }}</v-btn
          >
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex
          xs4
          sm6
          md6
          lg3
          xl2
          pr-11
          style="display: flex; justify-content: end"
        >
          <v-form>
            <v-text-field
              v-model="search"
              outlined
              :autofocus="'autofocus'"
              dense
              color="#2f9a61"
              :placeholder="$t('searchcodenamemailph')"
              class="text"
              style="border-color: #d9d9d9; height: 40px; width: 300px"
            >
              <v-icon slot="append" class="searchicon">mdi-magnify</v-icon>
            </v-text-field>
          </v-form>
        </v-flex>
      </v-layout>

      <!-- ******** filters -->

      <div v-if="activeTab !== 'removed'">
        <v-row class="ma-1 px-2">
          <v-col cols="12" class="pb-0">
            <v-row class="d-flex">
              <v-col cols="12" lg="2" class="py-0">
                <label
                  style="
                    font-size: 16px;
                    color: #424242;
                    font-weight: bold;
                    margin-top: 5px;
                  "
                  >{{ $t("registrationDate") }}</label
                >
                <v-menu
                  v-model="frommenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="startdate"
                      prepend-inner-icon="mdi-calendar-blank-outline"
                      outlined
                      dense
                      readonly
                      v-bind="attrs"
                      placeholder="yyyy/mm/dd"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="startdate"
                    @input="frommenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" lg="2" class="py-0">
                <label
                  style="
                    font-size: 16px;
                    color: #47484b;
                    font-weight: bold;
                    margin-top: 5px;
                  "
                  >{{ $t("to") }}
                </label>
                <v-menu
                  v-model="tomenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="enddate"
                      prepend-inner-icon="mdi-calendar-blank-outline"
                      outlined
                      dense
                      placeholder="yyyy/mm/dd"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="enddate"
                    :allowed-dates="allowedEndDates"
                    @input="tomenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col
                cols="12"
                lg="3"
                class="pre-fix py-0"
                v-if="this.$store.getters.tabs != 'tab-4'"
              >
                <label
                  style="
                    font-size: 16px;
                    color: #47484b;
                    font-weight: bold;
                    margin-top: 5px;
                  "
                  >{{ $t("status") }}
                </label>
                <v-select
                  v-model="selectedStatus"
                  :items="StatusList"
                  hide-no-data
                  hide-details
                  item-text="text"
                  item-value="id"
                  solo
                  dense
                  placeholder="-- Please select --"
                  clearable
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.text }}</span>
                    </v-chip>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="ma-1 px-2">
          <v-col cols="12" class="pt-1 pb-1">
            <v-row class="d-flex">
              <v-col cols="12" lg="2" class="py-0">
                <label
                  style="
                    font-size: 16px;
                    color: #424242;
                    font-weight: bold;
                    margin-top: 5px;
                  "
                  >{{ $t("expirydate") }}</label
                >
                <v-menu
                  v-model="viewfrom"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="viewstartdate"
                      prepend-inner-icon="mdi-calendar-blank-outline"
                      outlined
                      dense
                      readonly
                      placeholder="yyyy/mm/dd"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="viewstartdate"
                    @change="viewfrom = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" lg="2" class="py-0">
                <label
                  style="
                    font-size: 16px;
                    color: #424242;
                    font-weight: bold;
                    margin-top: 5px;
                  "
                  >{{ $t("to") }}</label
                >
                <v-menu
                  v-model="viewto"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="viewenddate"
                      prepend-inner-icon="mdi-calendar-blank-outline"
                      outlined
                      dense
                      readonly
                      placeholder="yyyy/mm/dd"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="viewenddate"
                    :allowed-dates="allowedviewEndDates"
                    @change="viewto = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" lg="3" class="py-0 pre-fix">
                <label
                  style="
                    font-size: 16px;
                    color: #47484b;
                    font-weight: bold;
                    margin-top: 5px;
                  "
                  >{{ $t("businesstype") }}</label
                >
                <v-select
                  v-model="values"
                  :items="BusinessTypeList"
                  hide-no-data
                  placeholder="-- Please select --"
                  hide-details
                  solodense
                  item-text="thai_Name"
                  item-value="id"
                  dense
                  solo
                  clearable
                  multiple
                >
                  <template v-slot:prepend-item>
                    <v-list-item ripple @click="SelectAllBusinessType">
                      <v-list-item-action>
                        <v-icon :color="values.length > 0 ? '#a6cc39' : ''">{{
                          businessTypeListIcon
                        }}</v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>Select All</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.thai_Name }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text text-caption"
                      >(+{{ values.length - 1 }} others)</span
                    >
                  </template>
                </v-select>
              </v-col>
              <v-col
                cols="12"
                lg="4"
                xl="4"
                style="padding-top: 2.1rem"
                class="pb-0"
              >
                <v-btn
                  text
                  class="text-capitalize"
                  height="40"
                  style="
                    border: 1px solid #c0c0c0;
                    border-radius: 8px;
                    color: #424242;
                    font-size: 16px;
                  "
                  @click="clearAll()"
                  >{{ "Clear All" }}</v-btn
                >
                <v-btn
                  width="120"
                  height="40"
                  class="text-capitalize btn_hover_effect ml-5"
                  style="
                    color: #ffff;
                    border: 1px solid #a6cc39;
                    border-radius: 8px;
                    font-size: 16px;
                  "
                  color="#A6CC39"
                  @click="GetFilteredResult()"
                  >{{ $t("search") }}</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>

      <!-- ******** new company add -->
      <v-layout
        row
        wrap
        class="ml-7 mt-3"
        style="display: flex; justify-content: end"
      >
        <v-flex xs3 sm2 md2 lg2 xl1 class="pr-md-2 mt-md-1">
          <v-btn
            block
            color="#6cc8a0"
            dark
            class="text-capitalize"
            v-if="current == 'running'"
            @click="ExportCompanydata"
            >{{ $t("exportexcel") }}</v-btn
          >
        </v-flex>
        <v-flex
          xs8
          sm6
          md4
          lg2
          class="pr-md-12 mt-md-1"
          v-if="activeTab !== 'removed'"
        >
          <v-btn
            block
            color="#6cc8a0"
            v-on:click="openModalNew"
            dark
            class="text-capitalize"
          >
            {{ $t("newcompany") }}
          </v-btn>
        </v-flex>
      </v-layout>
      <!-- ******** datatable -->
      <v-data-table
        :mobile-breakpoint="0"
        :headers="headers"
        :items="current == 'running' ? newsData : removedData"
        hide-default-footer
        :page.sync="current == 'running' ? page : page_R"
        :items-per-page="current == 'running' ? itemsPerPage : itemsPerPage_R"
        @page-count="
          current == 'running' ? (pageCount = $event) : (pageCount_R = $event)
        "
        :search="search"
        :key="sortTable"
        :must-sort="true"
        @current-items="getFiltered"
        class="usertable p-horizontal my-5 mx-7"
      >
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:item.status="{ item }">
          <label
            v-if="current == 'running'"
            dark
            v-bind:style="{ color: getColor(item.status), fontSize: 14 + 'px' }"
          >
            <span v-if="item.status == 1" class="pl-4 pr-4">{{
              getText(item.status)
            }}</span>
            <span v-else class="pl-3 pr-3">{{ getText(item.status) }}</span>
          </label>
          <label
            v-if="current != 'running'"
            dark
            style="font-size: 14px; color: #ff0000"
          >
            <span class="pl-4 pr-4" v-if="item.status != 10">
              {{ $t("delete") }}
            </span>
          </label>
        </template>
        <template v-slot:item.carbs="{ item }">
          <v-layout justify-center style="display: flex">
            <div
              v-if="current == 'running'"
              style="cursor: pointer"
              class="pr-5 mr-3"
              @click="openModalEdit(item, 'edit')"
            >
              <label class="tablemanage">Edit</label>
            </div>
            <div
              v-if="current == 'running'"
              @click="openModalDel(item.companyId, item.abb)"
            >
              <label class="tablemanage">Delete</label>
            </div>
            <div
              v-if="current != 'running'"
              @click="retrieveCompanyFromRemovedList(item)"
            >
              <label class="tablemanage pr-5 mr-3" style="color: red"
                >Return</label
              >
            </div>
            <div
              v-if="current != 'running'"
              @click="openModalEdit(item, 'view')"
            >
              <label class="tablemanage">View</label>
            </div>
          </v-layout>
        </template>
      </v-data-table>
      <!-- datatable ******** -->

      <!-- ******** pagination, perpage -->
      <v-layout
        row="wrap"
        align-center
        class="mt-5"
        style="margin-right: -30px"
      >
        <v-spacer />
        <v-flex my-3 mr-5 style="min-width: 240px; max-width: 315px">
          <v-pagination
            v-if="current == 'running'"
            v-model="page"
            :length="pageCount"
            :total-visible="5"
            color="#E8E9EC"
          ></v-pagination>
          <v-pagination
            v-if="current != 'running'"
            v-model="page_R"
            :length="pageCount_R"
            :total-visible="5"
            color="#E8E9EC"
          ></v-pagination>
        </v-flex>

        <v-flex shrink my-3 style="min-width: 173px">
          <select
            v-if="current == 'running'"
            style="border:1px solid;border-color:#D9D9D9;border-radius:5pt; padding:5px;opacity:0.5;
              background-color: #FFFFFF;width:110px;color:#4D4F5C;box-shadow: 0px 1px 1px #00000029;height:36px;"
            class="perPageText"
            v-model="itemsPerPage"
          >
            <option value="10">10 of {{ totalCount }}</option>
            <option value="15">15 of {{ totalCount }}</option>
            <option value="20">20 of {{ totalCount }}</option>
            <option value="25">25 of {{ totalCount }}</option>
          </select>
          <select
            v-if="current != 'running'"
            style="border:1px solid;border-color:#D9D9D9;border-radius:5pt;padding:5px;
               background-color: #FFFFFF;width:110px;color:#707070;box-shadow: 0px 3px 6px #00000029;height:36px;"
            class="perPageText"
            v-model="itemsPerPage_R"
          >
            <option value="10">10 of {{ totalCount_R }}</option>
            <option value="15">15 of {{ totalCount_R }}</option>
            <option value="20">20 of {{ totalCount_R }}</option>
            <option value="25">25 of {{ totalCount_R }}</option>
          </select>
          <span>
            <v-icon style="margin: 0.5rem 0 0 -2rem; vertical-align: top"
              >mdi-chevron-down</v-icon
            >
          </span>
        </v-flex>
      </v-layout>
      <!-- pagination, perpage ******** -->
    </v-card>

    <!-- Modal -->
    <AddEditComModal
      v-show="showComModal"
      :title="modal_Title"
      :CompanyItem="ComData"
      :isOpen="showComModal"
      @close="closeComModal"
    ></AddEditComModal>

    <!-- <AddEditComModal
        v-show="isModalEditVisible"
        :title="'editcompany'"
        :EditComItem="editComData"
        @close="closeModalEdit"
      ></AddEditComModal> -->

    <ModalEye
      v-show="isModalEyeVisible"
      title="company"
      :companyId="companyId"
      :companyName="companyName"
      :telephoneNumber="telephoneNumber"
      :email="email"
      :editEmail="email"
      :empID="empID"
      :userID="userID"
      :userName="userName"
      :countryName="countryName"
      :cityName="cityName"
      :address="address"
      :note="note"
      @update:note="note = $event"
      :status="status"
      :abbreviation="abbreviation"
      :companyIndex="companyIndex"
      :pricePlan="pricePlan"
      :contactName="contactName"
      @close="closeModalEye"
    ></ModalEye>
    <ModalDel
      v-show="isModalDeleteVisible"
      :title="DeleteCoompanybyID"
      message="doyouwanttoremovethiscompany"
      :tempID="id"
      flag="removecompany"
      ref="modalDel"
      @close="closeModalDel"
    ></ModalDel>

    <v-dialog v-model="loadingDialog" persistent width="300">
      <v-card color="#FFF4EB" dark>
        <v-card-text class="black--text">
          Loading Please Wait...
          <v-progress-linear
            indeterminate
            color="#6CC8A0"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import GlobalMixin from "../Mixins/GlobalMixin";
import AddEditComModal from "./AddEditModal.vue";
// import Modal from "./Modal.vue";
import ModalEye from "./ModalEye.vue";
import ModalDel from "@/components/ModalDel.vue";
import TitleBlock from "@/components/global_component/TitleBlock";
import axios from "axios";
import enurl from "@/api/environment";
import store from "@/store";
import * as moment from "moment/moment";
import exceljs from "exceljs";
import { saveAs } from "file-saver";
export default {
  name: "Menu01",
  props: {},
  components: {
    AddEditComModal,
    TitleBlock,
    ModalEye,
    ModalDel
  },
  mixins: [GlobalMixin],
  data() {
    return {
      activeTab: "running", // default
      modal_Title: "newcompany",
      ComData: {},
      viewstartdate: "",
      viewenddate: "",
      searchcategory: null,
      searchtitle: null,
      searchtitle1: null,
      values: [],
      selectedStatus: null,
      StatusList: [
        { id: 0, text: "All" },
        { id: 1, text: "Active" },
        { id: 2, text: "Inactive" }
      ],
      BusinessTypeList: [],
      startdate: "",
      enddate: "",
      frommenu: false,
      tomenu: false,
      viewfrom: false,
      viewto: false,
      //......
      filteredItems: [],
      sortTable: 1,
      mo: false,
      current: "running",
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      page_R: 1,
      pageCount_R: 0,
      itemsPerPage_R: 10,
      totalCount_R: 0,
      totalCount: "",
      search: "",
      showComModal: false,
      //isModalEditVisible: false,
      isModalEyeVisible: false,
      isModalDeleteVisible: false,
      loadingDialog: false,
      userId: store.getters.userid,
      characters: "a-z,A-Z,0-9",
      size: 10,
      newsData: [],
      removedData: [],
      url: enurl.apiUrl,
      companyId: null,
      companyName: null,
      isocheck: false,
      telephoneNumber: null,
      email: null,
      countryName: null,
      lockstatus: false,
      cityName: null,
      contactName: null,
      address: null,
      note: null,
      start_date: null,
      reminder_date: null,
      expiry_date: null,
      status: null,
      id: null,
      password: null,
      userID: null,
      guestaccess: 2,
      userName: null,
      empID: null,
      abbreviation: null,
      check1: false,
      pricePlan: 1,
      companyIndex: null,
      table: true,
      DeleteCoompanybyID: null,
      packageName: null,
      businessTypeID: 0,
      businessTypeOther: null,
      numberOfFilesId: null,
      activeEmployee: null,
      lock: false,
      courseStatus: false,
      aiAnswerChecking: false,
      emailCheck: false,
      removed: {
        color: "#6CC8A0",
        backcolor: "#F0F0F7",
        border: "1px solid #6CC8A0"
      },
      running: {
        color: "#fff",
        backcolor: "#6CC8A0",
        border: "1px solid #6CC8A0"
      }
    };
  },

  mounted: function() {
    let self = this;
    let language = "en";
    if (language == "en") {
      self.changeLocale("en", "us", "English", 1);
    }
    self.GetAllCompany();
    self.GetAllCompany_R();
    self.GetBusinessTypeList();
  },
  computed: {
    businessTypeListIcon() {
      if (this.selectAllTitle) return "mdi-checkbox-marked";
      return "mdi-checkbox-blank-outline";
    },
    selectAllTitle() {
      return this.values.length === this.BusinessTypeList.length;
    },
    headers() {
      let self = this;
      if (self.current == "running") {
        return [
          {
            text: this.$t("abbre"),
            align: "left",
            value: "abb",
            width: "150px"
          },
          {
            text: this.$t("companyname"),
            align: "left",
            value: "companyName",
            width: "227px"
          },
          {
            text: this.$t("packagename"),
            align: "left",
            value: "packageName",
            width: "200px"
          },
          {
            text: this.$t("businesstype"),
            align: "left",
            value: "businessTypeIndex",
            width: "200px"
          },
          {
            text: this.$t("totalEmployee"),
            align: "left",
            value: "totalUser",
            width: "150px"
          },
          {
            text: this.$t("activeemployees"),
            align: "left",
            value: "activeEmployee",
            width: "160px"
          },
          {
            text: this.$t("numberoffiles"),
            align: "left",
            value: "numberOfFiles",
            width: "150px"
          },
          {
            text: this.$t("registrationDate"),
            align: "left",
            value: "createDate",
            width: "111px",
            sortable: false
          },
          {
            text: this.$t("expirydate"),
            align: "left",
            value: "expirydate",
            width: "180px"
          },
          {
            text: this.$t("contactname"),
            align: "left",
            value: "contactName",
            width: "227px"
          },
          {
            text: this.$t("email"),
            align: "left",
            value: "email",
            width: "264px"
          },
          {
            text: this.$t("telephoneno"),
            align: "left",
            value: "telNo",
            width: "111px",
            sortable: false
          },
          {
            text: this.$t("country"),
            align: "left",
            value: "country",
            width: "111px",
            sortable: false
          },

          {
            text: this.$t("status"),
            value: "status",
            align: "center",
            width: "120px"
          },
          {
            text: this.$t("manage"),
            align: "center",
            value: "carbs",
            width: "227px"
          }
        ];
      } else {
        return [
          {
            text: this.$t("abbre"),
            align: "left",
            value: "abb",
            width: "227px"
          },
          {
            text: this.$t("companyname"),
            align: "left",
            value: "companyName",
            width: "227px"
          },
          {
            text: this.$t("email"),
            align: "left",
            value: "email",
            width: "264px"
          },
          {
            text: this.$t("telephoneno"),
            align: "left",
            value: "telNo",
            width: "111px",
            sortable: false
          },
          {
            text: this.$t("status"),
            value: "status",
            align: "center"
          },
          {
            text: this.$t("manage"),
            align: "center",
            value: "carbs"
          }
        ];
      }
    },
    headers_R() {
      return [
        {
          text: this.$t("companyname"),
          align: "left",
          value: "companyName"
        },

        {
          text: this.$t("telephoneno"),
          align: "left",
          value: "telNo",
          width: "111px",
          sortable: false
        },
        {
          text: this.$t("status"),
          value: "status",
          align: "center"
        }
      ];
    }
  },

  methods: {
    async GetFilteredResult() {
      let that = this;
      let request = {
        companyType: that.current,
        registerFromDate: that.startdate,
        registerToDate: that.enddate,
        expiryFromDate: that.viewstartdate,
        expiryToDate: that.viewenddate,
        statusID: that.selectedStatus,
        businessTypeIDs: that.values
      };
      that.loadingDialog = true;
      await axios
        .post(`${that.url}Company/GetCompanyFilteredResult`, request)
        .then(function(response) {
          if (response.data.status == 0) {
            if (that.current === "running") {
              let cmpdata = response.data.data.map(v => ({
                ...v,
                createDate: moment(v.createDate)
                  .local()
                  .format("DD/MM/YYYY"),
                expirydate: v.expiryDate
                  ? moment(v.expiryDate)
                      .local()
                      .format("DD/MM/YYYY")
                  : "",
                startDate: v.startDate ? v.startDate.split("T")[0] : "",
                reminderDate: v.reminderDate
                  ? v.reminderDate.split("T")[0]
                  : "",
                expiryDate: v.expiryDate ? v.expiryDate.split("T")[0] : ""
              }));
              let othertype = [];
              for (const element of cmpdata) {
                let List = [];
                if (element.businessType == "อื่นๆ") {
                  List = {
                    ...element,
                    businessTypeIndex: element.businessTypeOther
                  };
                } else {
                  List = {
                    ...element,
                    businessTypeIndex: element.businessType
                  };
                }
                othertype.push(List);
              }
              that.newsData = othertype.filter(
                d => d.companyName != "Fusion Solution Test"
              );
              that.totalCount = response.data.data.length;
            } else {
              let data = response.data.data.sort(
                (a, b) => new Date(b.updateDate) - new Date(a.updateDate)
              );
              that.removedData = data.map(v => ({
                ...v,
                telNo: that.getTelNo(v.telNo)
              }));
              that.totalCount_R = response.data.data.length;
              if (that.pageCount_R == 0) {
                that.pageCount_R = that.pageCount;
              }
            }
            that.loadingDialog = false;
          }
        })
        .catch(function(err) {
          that.loadingDialog = false;
          throw err;
        });
    },
    clearAll() {
      this.selectedStatus = null;
      this.values = [];
      this.enddate = "";
      this.startdate = "";
      this.viewstartdate = "";
      this.viewenddate = "";
      if (this.current === "running") {
        this.GetAllCompany();
      } else {
        this.GetAllCompany_R();
      }
    },
    allowedviewEndDates(val) {
      return val >= this.viewstartdate;
    },
    allowedEndDates(val) {
      return val >= this.startdate;
    },
    GetBusinessTypeList() {
      let self = this;
      axios.get(`${self.url}Company/GetBusinessType`).then(function(response) {
        if (response.data.status == 0) {
          self.BusinessTypeList = response.data.data;
        }
      });
    },
    SelectAllBusinessType() {
      if (this.values.length == 0) {
        this.values = this.BusinessTypeList.map(({ id }) => id);
      } else {
        this.values = [];
      }
    },
    changeLocale(locale, flag, title, highlighted) {
      this.currentflag = flag;
      this.$i18n.locale = locale;
      this.currentLangTitle = title;
      this.lang = highlighted;
      document.cookie = "langprod=" + locale;
      document.cookie = "flagprod=" + flag;
      document.cookie = "titleprod=" + title;
      document.cookie = "highlighted=" + highlighted;
    },
    resetOnTabChange() {
      let self = this;
      self.search = null;
      self.page = 1;
      self.page_R = 1;
    },
    onClickRunning() {
      this.activeTab = "running";
      let self = this;
      self.selectedStatus = null;
      self.values = [];
      self.enddate = "";
      self.startdate = "";
      self.viewstartdate = "";
      self.viewenddate = "";
      self.resetOnTabChange();
      self.GetAllCompany();
      self.current = "running";
      self.running = {
        color: "#fff",
        backcolor: "#6CC8A0",
        border: "1px solid #6CC8A0"
      };
      self.page = 1;
      self.removed = {
        color: "#6CC8A0",
        backcolor: "#F0F0F7",
        border: "1px solid #6CC8A0"
      };
      self.sortTable = 1;
      self.table = true;
    },
    onClickRemoved() {
      this.activeTab = "removed";
      let self = this;
      self.selectedStatus = null;
      self.values = [];
      self.enddate = "";
      self.startdate = "";
      self.viewstartdate = "";
      self.viewenddate = "";
      self.resetOnTabChange();
      self.GetAllCompany_R();
      self.current = "remove";
      self.removed = {
        color: "#fff",
        backcolor: "#6CC8A0",
        border: "1px solid #6CC8A0"
      };
      self.page_R = 1;
      self.running = {
        color: "#6CC8A0",
        backcolor: "#F0F0F7",
        border: "1px solid #6CC8A0"
      };
      self.sortTable = 2;
      self.table = false;
    },
    // New
    openModalNew() {
      this.modal_Title = "newcompany";
      this.abbreviation = null;
      this.check1 = false;
      this.showComModal = true;
      this.userName = null;
      this.password = null;
      this.contactName = null;
      let a = this.totalCount + 1;
      if (a < 100) {
        this.userName = "UID000" + a;
      } else if (a < 1000) {
        this.userName = "UID00" + a;
      } else if (a < 10000) {
        this.userName = "UID0" + a;
      } else {
        this.userName = "UID" + a;
      }
      this.password = this.generate();

      this.ComData = {
        empID: this.empID,
        userID: this.userID,
        userName: this.userName,
        password: this.password,
        abbreviation: this.abbreviation,
        companyIndex: this.companyIndex,
        check1: this.check1,
        contactName: this.contactName,
        selectedEmailLang: this.selectedEmailLang
      };
    },
    closeComModal() {
      this.showComModal = false;
    },
    searchName() {
      return this.$t("searchcodenamemailph");
    },
    //return to running
    retrieveCompanyFromRemovedList(temp) {
      this.loadingDialog = true;
      let request = { companyId: temp.companyId };
      axios
        .post(`${this.url}Company/UndoCompany`, request)
        .then(function(response) {
          if (response.data.status == 0) {
            window.location.reload();
            this.loadingDialog = false;
          }
        })
        .catch(function(error) {
          this.loadingDialog = false;
          console.log("Something went wrong.");
        });
    },

    // Edit
    openModalEdit(temp, v) {
      console.log("temp go to edit", temp);

      if (v === "view") {
        // ✅ Open the same modal as 'edit', but without filling ComData
        this.modal_Title = "viewcompany"; // optional, or reuse edit title
        this.showComModal = true; // use same popup
        this.isModalEyeVisible = false; // disable old popup
        this.ComData = {}; // do NOT prefill for view mode
        return; // ✅ stop here (skip API + data fill)
      }

      // ✅ existing logic for edit + eye
      this.modal_Title = "editcompany";
      if (v === "edit") this.showComModal = true;
      if (v === "eye") this.isModalEyeVisible = true;

      this.ComData = {
        companyId: temp.companyId,
        companyName: temp.companyName,
        telephoneNumber: temp.telNo,
        email: temp.email,
        countryName: temp.country,
        lockstatus: temp.lockstatus,
        cityName: temp.city,
        address: temp.address,
        note: temp.note,
        status: temp.status,
        abbreviation: temp.abb,
        cur_appr: temp.abb,
        companyIndex: temp.companyIndex,
        pricePlan: temp.pricePlan,
        packageName: temp.packageId,
        businessTypeID: temp.businessTypeID,
        businessTypeOther: temp.businessTypeOther,
        numberOfFilesId: temp.numberOfFile,
        activeEmployee: temp.activeEmpId,
        start_date: temp.startDate,
        reminder_date: temp.reminderDate,
        expiry_date: temp.expiryDate,
        isocheck: temp.isoAccess,
        lock: temp.lock,
        courseStatus: temp.courseStatus,
        aiAnswerChecking: temp.aiAnswerChecking,
        subjectiveTest: temp.subjectiveTest,
        password: "******",
        selectedEmailLang: temp.emailLanguage,
        check1: false,
        paymentStatus: temp.paymentStatus,
        paymentId: temp.paymentId,
        saleName: temp.salesName,
        sellingPrice: temp.sellingPrice,
        startdatesale: temp.paymentDate,
        purchasePeriod: temp.purchasePeriod
      };

      let self = this;
      self.loadingDialog = true;
      axios
        .post(
          `${self.url}Company/GetCompanyJoinByCompanyId?id=${temp.companyId}`
        )
        .then(function(response) {
          if (response.data.status == 0) {
            let apiData = {
              userName: response.data.data.username,
              userID: response.data.data.userID,
              password: "******",
              empID: response.data.data.employeeID,
              lockstatus: response.data.data.lockstatus,
              contactName: response.data.data.contactName
            };
            self.ComData = { ...self.ComData, ...apiData };
          }
          self.loadingDialog = false;
        })
        .catch(function(error) {
          self.loadingDialog = false;
          alert(error);
        });
    },

    closeModalEye() {
      this.isModalEyeVisible = false;
    },
    // Delete
    openModalDel(item, item1) {
      this.isModalDeleteVisible = true;
      this.id = item;
      this.DeleteCoompanybyID = "Delete Company Code '" + item1 + "'";
    },
    closeModalDel() {
      this.isModalDeleteVisible = false;
    },
    getColor(item) {
      if (item == "1") return "#4B9160";
      else return "#EB2127";
    },
    getText(item) {
      if (item == "1") return this.$t("active");
      else return this.$t("inactive");
    },
    GetAllCompany() {
      let self = this;
      self.loadingDialog = true;
      self.password = self.generate();
      axios
        .post(`${self.url}Company/GetALLCompany`)
        .then(function(response) {
          self.loadingDialog = false;
          let cmpdata = response.data.data.map(v => ({
            ...v,
            createDate: moment(v.createDate)
              .local()
              .format("DD/MM/YYYY"),
            expirydate: v.expiryDate
              ? moment(v.expiryDate)
                  .local()
                  .format("DD/MM/YYYY")
              : "",
            startDate: v.startDate ? v.startDate.split("T")[0] : "",
            reminderDate: v.reminderDate ? v.reminderDate.split("T")[0] : "",
            expiryDate: v.expiryDate ? v.expiryDate.split("T")[0] : ""
          }));
          let othertype = [];
          for (const element of cmpdata) {
            let List = [];
            if (element.businessType == "อื่นๆ") {
              List = {
                ...element,
                businessTypeIndex: element.businessTypeOther
              };
            } else {
              List = {
                ...element,
                businessTypeIndex: element.businessType
              };
            }
            othertype.push(List);
          }
          self.newsData = othertype.filter(
            d => d.companyName != "Fusion Solution Test"
          );
          self.totalCount = response.data.data.length;
        })
        .catch(function(error) {
          self.loadingDialog = false;
        });
    },
    GetAllCompany_R() {
      let self = this;
      self.password = self.generate();
      axios
        .post(`${self.url}Company/GetALLRemovedCompany`)
        .then(function(response) {
          let data = response.data.data.sort(
            (a, b) => new Date(b.updateDate) - new Date(a.updateDate)
          );
          self.removedData = data.map(v => ({
            ...v,
            telNo: self.getTelNo(v.telNo)
          }));
          self.totalCount_R = response.data.data.length;
          if (self.pageCount_R == 0) {
            self.pageCount_R = self.pageCount;
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },

    getTelNo(v) {
      if (v) {
        return "" + v;
      } else {
        return "-";
      }
    },

    // GetComJoin(temp) {
    //   let self = this;
    //   axios
    //     .post(
    //       `${self.url}Company/GetCompanyJoinByCompanyId?id=${temp.companyId}`
    //     )
    //     .then(function (response) {
    //       this.isModalEditVisible = true;
    //       this.companyId = temp.companyId;
    //       this.companyName = temp.companyName;
    //       this.telephoneNumber = temp.telNo;
    //       this.email = temp.email;
    //       this.countryName = temp.country;
    //       this.cityName = temp.city;
    //       this.note = temp.note;
    //       this.address = temp.address;
    //       this.status = temp.status;
    //       this.abbreviation = temp.abb;
    //       this.check1 = false;
    //       this.userID = null;
    //       this.password = "******";
    //       this.empID = null;
    //       this.emailCheck = temp.emailcheck;
    //       this.lock = temp.lock;
    //       this.courseStatus = temp.courseStatus;
    //     })
    //     .catch(function (error) {
    //       alert(error);
    //     });
    // },

    generate() {
      let charactersArray = this.characters.split(",");
      let CharacterSet = "";
      let tempPassword = "";

      if (charactersArray.indexOf("a-z") >= 0) {
        CharacterSet += "abcdefghijklmnopqrstuvwxyz";
      }
      if (charactersArray.indexOf("A-Z") >= 0) {
        CharacterSet += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      }
      if (charactersArray.indexOf("0-9") >= 0) {
        CharacterSet += "0123456789";
      }
      if (charactersArray.indexOf("#") >= 0) {
        CharacterSet += "![]{}()%&*$#^<>~@|";
      }

      for (let i = 0; i < this.size; i++) {
        tempPassword += CharacterSet.charAt(
          Math.floor(Math.random() * CharacterSet.length)
        );
      }
      return tempPassword;
    },
    getFiltered(e) {
      let self = this;
      self.filteredItems = e;
    },
    ExportCompanydata() {
      let item_temp = this.search ? this.filteredItems : this.newsData;
      let headers = [
        "Company Code",
        "Company Name",
        "Package Name",
        "Business Type",
        "Total Employees",
        "Active Employees",
        "Number of files",
        "Registration Date",
        "Expiry Date",
        "Contact Name",
        "Email",
        "Telephone No",
        "Status"
      ];
      const keys = [
        "abb",
        "companyName",
        "packageName",
        "businessTypeIndex",
        "totalUser",
        "activeEmployee",
        "numberOfFiles",
        "createDate",
        "expirydate",
        "contactName",
        "email",
        "telNo",
        "status"
      ];
      const fileName = `CompanyReport.xlsx`;
      const filterItems = item_temp.map(x => ({
        ...x,
        status: this.getText(x.status)
      }));

      const data = [];
      data.push(headers);
      for (const item of filterItems) {
        let row = [];

        for (const key of keys) {
          row.push(item[key] || "");
        }
        data.push(row);
      }
      let workbook2 = new exceljs.Workbook();

      workbook2.addWorksheet("Company Data", {
        views: [{ showGridLines: true }]
      });
      let worksheet2 = workbook2.getWorksheet(1);

      data.forEach(element => {
        worksheet2.addRow(element);
      });
      worksheet2.getRow(1).eachCell((cell, number) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "ff9900" },
          bgColor: { argb: "ff9900" }
        };
        cell.font = {
          name: "Calibri",
          size: 11,
          color: { argb: "000000" },
          bold: true
        };
        cell.alignment = { vertical: "middle", horizontal: "center" };
      });
      worksheet2.getRows(1, worksheet2.actualRowCount - 1).forEach(x =>
        x.eachCell(cell => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" }
          };
          cell.alignment = { vertical: "middle", horizontal: "center" };
        })
      );
      worksheet2.lastRow.eachCell(cell => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" }
        };
        cell.alignment = { vertical: "middle", horizontal: "center" };
      });
      worksheet2.columns.forEach((column, i) => {
        column.width = headers[i].length + (i <= 10 ? 15 : 19);
      });
      workbook2.xlsx.writeBuffer().then(val => {
        let blob = new Blob([val], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
        });
        saveAs(blob, fileName);
      });
    }
  }
};
</script>

<style scoped>
.btnactive {
  background-color: #004a17 !important;
  color: rgba(255, 255, 255, 1) !important;
}
.a {
  fill: #43425d;
}
.editButton :hover {
  fill: #4b9160;
}
.jv-breadcrumb {
  background-color: #13322c;
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
  border-radius: 0;
  border: none;
}
.jv-breadcrumb p {
  padding: 15px 10px;
}

.jv-content {
  margin: 1.5rem 2rem;
  padding: 1.5rem 2rem;
  background-color: rgba(255, 255, 255, 1);
  border: none;
}
@media only screen and (max-width: 600px) {
  .jv-content {
    margin: 1.5rem 0;
  }
}
.btn-new {
  border-color: #13322c;
}
.btn-new:hover {
  border-color: #4caf50 !important;
  background-color: #4caf50 !important;
}
.jv-sub {
  display: inline;
  padding-left: 20px;
  color: rgba(47, 154, 97, 1);
  font-weight: bold;
}

.jv-announcements {
  margin: 10px 15px 0;
  padding: 15px 0px 10px;
  /* border-bottom: 1px solid rgba(233, 233, 240, 1); */
}
.jv-announcements p {
  font-size: 14px;
  color: rgba(67, 66, 93, 1);
}

.btn-group {
  margin: 0 auto;
  padding-top: 25px;
  width: auto;
}
.btn-group button {
  margin: 0 10px;
  border-color: rgba(232, 233, 236, 1);
  color: rgba(77, 79, 92, 1);
  border-radius: 3px !important;
}
.btn-group button.active {
  background-color: #13322c !important;
  border-color: #13322c !important;
}

thead {
  border-bottom: 1px solid #13322c;
}
tbody tr:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.05);
}

tbody tr:hover td {
  background-color: #ffffff !important;
}
</style>

<style scoped>
.switch-btn {
  min-width: 100px;
  width: 150px;
}
@media only screen and (max-width: 600px) {
  .switch-btn {
    min-width: 110px;
    width: auto;
  }
}
.mdi-close:hover {
  color: red !important;
}
.searchText {
  height: 34px;
  width: 400px;
  font-size: 14px;
}
.for-hover:hover {
  color: white !important;
}
.v-data-table >>> thead {
  font: 15px "Source Sans Pro", sans-serif;
  letter-spacing: 0;
  background-color: #dbdbda;
}
.searchicon {
  background-color: #6cc8a0;
  padding-top: 3px;
  margin-right: -12px;
  margin-top: -8px;
  margin-bottom: -6px;
  height: 40px;
  width: 40px;
}
.tablemanage {
  cursor: pointer;
  color: #6cc8a0;
}
/* ::v-deep .v-pagination__item {
    color: #4d4f5c !important;
    opacity: 0.5 !important;
  } */

@media only screen and (max-width: 768px) {
  .card-mobile {
    margin-left: 1rem !important;
  }
  .floating {
    margin-left: 10px;
  }
}

@media only screen and (max-width: 600px) {
  .company-title-div-mobile {
    padding: 10%;
    margin-left: 0.5%;
  }
}

@media only screen and (max-width: 414px) {
  .company-title-div-mobile {
    padding: 10%;
    margin-left: 2%;
  }
  .floating {
    margin-left: 0;
  }
}

@media only screen and (max-width: 375px) {
  .company-title-div-mobile {
    padding: 5%;
    margin-left: 5%;
  }
}

@media only screen and (max-width: 320px) {
  .company-title-div-mobile {
    padding: 5%;
    margin-left: 5%;
  }

  .company-title-text-mobile {
    width: 113% !important;
    font-size: 20px;
  }
}
</style>
<style scoped>
::v-deep .pre-fix .v-input__slot {
  border: 1px solid #707070;
  font-size: 16px !important;
  border-radius: 4px !important;
}
::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  min-height: 38px !important;
  box-shadow: unset;
}
</style>
